import styled, { keyframes, css } from 'styled-components';
const pulse = keyframes `
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;
export const StatsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
  @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
`;
export const StatCard = styled.div `
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 1.25rem;
  border-left: 4px solid ${p => p.$accent || 'var(--accent-gold)'};
  h3 { margin: 0 0 0.25rem; font-size: 1.75rem; color: var(--text-primary); font-weight: 700; }
  p { margin: 0; font-size: 0.8rem; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.05em; }
`;
export const FilterBar = styled.div `
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  @media (max-width: 768px) { flex-direction: column; align-items: stretch; }
`;
export const SearchInput = styled.input `
  flex: 1;
  min-width: 200px;
  padding: 0.625rem 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.875rem;
  &::placeholder { color: var(--text-secondary); }
  &:focus { outline: none; border-color: var(--accent-gold); }
`;
export const FilterSelect = styled.select `
  padding: 0.625rem 1rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.875rem;
  cursor: pointer;
  &:focus { outline: none; border-color: var(--accent-gold); }
`;
export const ActionButton = styled.button `
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
  ${p => p.$variant === 'primary' ? css `
    background: var(--accent-gold);
    color: #000;
    border-color: var(--accent-gold);
    &:hover { filter: brightness(1.1); }
  ` : p.$variant === 'danger' ? css `
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    border-color: #ef4444;
    &:hover { background: rgba(239, 68, 68, 0.2); }
  ` : css `
    background: var(--bg-secondary);
    color: var(--text-primary);
    border-color: var(--border-color);
    &:hover { background: var(--bg-tertiary, rgba(255,255,255,0.05)); }
  `}
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
export const ShipmentCardWrapper = styled.div `
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  margin-bottom: 0.75rem;
  overflow: hidden;
  transition: all 0.2s;
  ${p => p.$expanded && css `border-color: var(--accent-gold);`}
  &:hover { border-color: var(--accent-gold); }
`;
export const CardHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  cursor: pointer;
  gap: 1rem;
  &:hover { background: rgba(255, 255, 255, 0.02); }
`;
export const CardHeaderLeft = styled.div `
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 0;
`;
export const CardHeaderRight = styled.div `
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
`;
export const CardBody = styled.div `
  max-height: ${p => p.$expanded ? '2000px' : '0'};
  opacity: ${p => p.$expanded ? 1 : 0};
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.2s ease;
  padding: ${p => p.$expanded ? '0 1.25rem 1.25rem' : '0 1.25rem'};
  border-top: ${p => p.$expanded ? '1px solid var(--border-color)' : 'none'};
`;
export const StatusBadge = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  ${p => {
    switch (p.$status) {
        case 'delivered': return css `background: rgba(16,185,129,0.15); color: #10b981;`;
        case 'in_transit': return css `background: rgba(59,130,246,0.15); color: #3b82f6;`;
        case 'draft': return css `background: rgba(156,163,175,0.15); color: #9ca3af;`;
        case 'imported': return css `background: rgba(168,85,247,0.15); color: #a855f7;`;
        case 'exception': return css `background: rgba(239,68,68,0.15); color: #ef4444;`;
        case 'voided': return css `background: rgba(107,114,128,0.15); color: #6b7280;`;
        default: return css `background: rgba(156,163,175,0.15); color: #9ca3af;`;
    }
}}
`;
export const TrackingNumber = styled.span `
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.875rem;
  color: var(--accent-gold);
  font-weight: 600;
`;
export const CardMeta = styled.span `
  font-size: 0.8rem;
  color: var(--text-secondary);
`;
// Wizard components
export const WizardContainer = styled.div `
  max-width: 800px;
  margin: 0 auto;
`;
export const WizardStepIndicator = styled.div `
  display: flex;
  justify-content: center;
  gap: 0;
  margin-bottom: 2rem;
  position: relative;
`;
export const WizardStep = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  .step-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    border: 2px solid;
    transition: all 0.3s;
    ${p => p.$completed ? css `
      background: var(--accent-gold);
      border-color: var(--accent-gold);
      color: #000;
    ` : p.$active ? css `
      background: transparent;
      border-color: var(--accent-gold);
      color: var(--accent-gold);
    ` : css `
      background: transparent;
      border-color: var(--border-color);
      color: var(--text-secondary);
    `}
  }
  .step-label {
    font-size: 0.75rem;
    color: ${p => p.$active || p.$completed ? 'var(--text-primary)' : 'var(--text-secondary)'};
    font-weight: ${p => p.$active ? '600' : '400'};
    text-align: center;
  }
`;
export const WizardContent = styled.div `
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 2rem;
`;
export const WizardActions = styled.div `
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
`;
// Import Modal
export const ModalOverlay = styled.div `
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
`;
export const ModalContent = styled.div `
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 560px;
  max-height: 80vh;
  overflow-y: auto;
  h2 { margin: 0 0 0.5rem; color: var(--text-primary); font-size: 1.25rem; }
  p { color: var(--text-secondary); font-size: 0.875rem; margin-bottom: 1rem; }
`;
export const ModalTextarea = styled.textarea `
  width: 100%;
  min-height: 120px;
  padding: 0.75rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.875rem;
  resize: vertical;
  &:focus { outline: none; border-color: var(--accent-gold); }
`;
export const ModalActions = styled.div `
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
`;
export const ImportResultItem = styled.div `
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 0.875rem;
  color: ${p => p.$success ? '#10b981' : p.$duplicate ? '#f59e0b' : '#ef4444'};
  border-bottom: 1px solid var(--border-color);
  &:last-child { border-bottom: none; }
  .tracking { font-family: 'JetBrains Mono', monospace; }
`;
// Mock mode (reuse FinancialHub pattern)
export const MockModeToggle = styled.button `
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${p => p.active ? 'rgba(16, 185, 129, 0.15)' : 'var(--bg-tertiary, rgba(255,255,255,0.05))'};
  color: ${p => p.active ? '#10b981' : 'var(--text-secondary)'};
  border: 1px solid ${p => p.active ? '#10b981' : 'var(--border-color)'};
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  svg { font-size: 1.25rem; }
  &:hover { background: ${p => p.active ? 'rgba(16, 185, 129, 0.25)' : 'var(--bg-secondary)'}; }
  @media (max-width: 768px) { padding: 0.5rem 1rem; font-size: 0.8rem; }
`;
export const MockModeBadge = styled.div `
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid #10b981;
  color: #10b981;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 1rem;
  text-align: center;
  &:hover { background: rgba(16, 185, 129, 0.2); }
`;
export const MockInfoBanner = styled.div `
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.1));
  border: 2px solid #10b981;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
`;
export const ConnectionDot = styled.span `
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${p => p.$connected ? '#00c853' : '#ff1744'};
  margin-left: 8px;
  box-shadow: 0 0 6px ${p => p.$connected ? 'rgba(0, 200, 83, 0.5)' : 'rgba(255, 23, 68, 0.5)'};
`;
export const AccountSelector = styled.select `
  padding: 6px 10px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  min-width: 140px;
  &:focus { outline: none; border-color: var(--accent-gold); }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
export const ConnectionStatus = styled.div `
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
  padding: 6px 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
`;
// Skeleton loading
export const SkeletonCard = styled.div `
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 1.25rem;
  margin-bottom: 0.75rem;
  animation: ${pulse} 2s ease-in-out infinite;
  height: 80px;
`;
// Detail panel
export const DetailGrid = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 1rem;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;
export const DetailSection = styled.div `
  h4 { margin: 0 0 0.75rem; color: var(--accent-gold); font-size: 0.875rem; text-transform: uppercase; letter-spacing: 0.05em; }
`;
export const DetailRow = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 0.4rem 0;
  font-size: 0.85rem;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  .label { color: var(--text-secondary); }
  .value { color: var(--text-primary); font-weight: 500; }
`;
export const DocLink = styled.a `
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--accent-gold);
  font-size: 0.85rem;
  text-decoration: none;
  padding: 0.35rem 0.75rem;
  border: 1px solid var(--accent-gold);
  border-radius: 6px;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  &:hover { background: rgba(212, 175, 55, 0.1); }
`;
export const EmptyState = styled.div `
  text-align: center;
  padding: 3rem;
  color: var(--text-secondary);
  h3 { color: var(--text-primary); margin-bottom: 0.5rem; }
  p { margin-bottom: 1rem; }
`;
// Form components for wizard
export const FormGroup = styled.div `
  margin-bottom: 1.25rem;
  label { display: block; font-size: 0.8rem; color: var(--text-secondary); margin-bottom: 0.35rem; text-transform: uppercase; letter-spacing: 0.05em; }
`;
export const FormInput = styled.input `
  width: 100%;
  padding: 0.625rem 0.75rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.875rem;
  &:focus { outline: none; border-color: var(--accent-gold); }
  &:disabled { opacity: 0.5; }
`;
export const FormSelect = styled.select `
  width: 100%;
  padding: 0.625rem 0.75rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.875rem;
  cursor: pointer;
  &:focus { outline: none; border-color: var(--accent-gold); }
`;
export const FormRow = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  @media (max-width: 640px) { grid-template-columns: 1fr; }
`;
export const AddressCard = styled.div `
  background: var(--bg-primary);
  border: 2px solid ${p => p.$selected ? 'var(--accent-gold)' : 'var(--border-color)'};
  border-radius: 10px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  ${p => p.$selected && css `box-shadow: 0 0 12px rgba(212, 175, 55, 0.2);`}
  &:hover { border-color: var(--accent-gold); }
  h4 { margin: 0 0 0.5rem; color: var(--text-primary); font-size: 0.9rem; }
  p { margin: 0.15rem 0; color: var(--text-secondary); font-size: 0.8rem; }
`;
export const CostTable = styled.table `
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  td { padding: 0.5rem 0; font-size: 0.875rem; border-bottom: 1px solid rgba(255,255,255,0.05); }
  td:first-child { color: var(--text-secondary); }
  td:last-child { text-align: right; color: var(--text-primary); font-weight: 500; }
  tr:last-child td { border-bottom: 2px solid var(--accent-gold); font-weight: 700; font-size: 1rem; }
`;
export const TotalAmount = styled.div `
  text-align: right;
  margin-top: 1rem;
  font-size: 2rem;
  font-weight: 700;
  color: var(--accent-gold);
`;
